
import { SMAlert } from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class Toolbar extends Vue {
  alertSuccess = SMAlert.alertSuccess;
  alertError = SMAlert.alertError;

  get successStatus() {
    return SMAlert.alertSuccess;
  }

  get errorStatus() {
    return SMAlert.alertError;
  }

  @Watch("successStatus", { immediate: true })
  successStatusChanged(value: boolean) {
    this.alertSuccess = value;
  }

  @Watch("errorStatus", { immediate: true })
  errorStatusChanged(value: boolean) {
    this.alertError = value;
  }

  closeAlert() {
    SMAlert.setAlertSuccess(false);
    SMAlert.setAlertError(false);
    this.alertSuccess = false;
    this.alertError = false;
  }
}
